module.exports = new __parcel__URL__("address_icon.0199716d.svg").toString();